import { useParams } from '@tanstack/react-router'

/** The `:orgId` route param for /admin/tenants/:orgId. Under /preview there is no param; falls back to the mock tenant. */
export function useOrgId(): string {
  const params = useParams({ strict: false }) as { orgId?: string }
  return params.orgId ?? 'org_dtlr'
}
